var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "workspaces-list-container" },
    [
      _c(
        "v-card-text",
        { staticClass: "workspace-card" },
        [
          _c("v-text-field", {
            staticStyle: { padding: "0px 10px" },
            attrs: {
              label: "Search",
              clearable: "",
              "append-icon": _vm.searchText ? "mdi-close" : "mdi-magnify"
            },
            on: { clear: _vm.clearSearch },
            model: {
              value: _vm.searchText,
              callback: function($$v) {
                _vm.searchText = $$v
              },
              expression: "searchText"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "scrollable-list" },
            [
              _c(
                "v-radio-group",
                {
                  attrs: { value: _vm.selectedWorkspace },
                  on: { change: _vm.setSelectedWorkspace }
                },
                [
                  !_vm.isLoading
                    ? _c(
                        "v-list",
                        _vm._l(_vm.filteredWorkspaces, function(item, index) {
                          return _c(
                            "v-list-item",
                            {
                              key: index,
                              staticStyle: {
                                "border-bottom": "1px rgb(139, 137, 137) solid"
                              }
                            },
                            [
                              _c(
                                "v-list-item-action",
                                [
                                  _c("v-radio", {
                                    attrs: { color: "#67a0b4", value: item }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item-content",
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "list-item-title" },
                                    [_vm._v(_vm._s(item.wp_label))]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _c("v-progress-linear", {
                        attrs: { indeterminate: true, color: "primary" }
                      })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ccbb43e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ccbb43e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Npv/Configuration/components/WorkspacesList.vue
// module id = null
// module chunks = 